var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"app"}},[_c('VinToaster'),_c('AppModals'),(_vm.showCookies)?_c('CookieBanner'):_vm._e(),_c('AccessBanner'),_c(_vm.view,{tag:"component",style:(_vm.showForMimic || _vm.showForOrgTree ? 'paddingTop:40px' : ''),attrs:{"id":"fleet-main"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }